import { render, staticRenderFns } from "./TestNoteList.vue?vue&type=template&id=77aeaf38"
import script from "./TestNoteList.vue?vue&type=script&lang=js"
export * from "./TestNoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77aeaf38')) {
      api.createRecord('77aeaf38', component.options)
    } else {
      api.reload('77aeaf38', component.options)
    }
    module.hot.accept("./TestNoteList.vue?vue&type=template&id=77aeaf38", function () {
      api.rerender('77aeaf38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/note/TestNoteList.vue"
export default component.exports